import { ConfigProvider, Select } from "antd";
import React from "react";

const CustomSelect = ({
  placeholder,
  width = "100%",
  value,
  onChange,
  options,
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            colorBorder: "var(--border-primary)",
            selectorBg: "transparent",
            borderRadius: "15px",
            colorText: "var(--text-primary)",
            colorTextPlaceholder: "var(--text-primary)",
            controlPaddingHorizontalSM: "15",
            multipleSelectorBgDisabled: "var(--text-primary)",
            colorBgElevated: "var(--background-secondary)",
            multipleItemBorderColorDisabled: "var(--border-primary)",
            multipleItemBg: "var(--background-primary)",
            optionSelectedBg: "var(--background-primary)",
          },
        },
      }}
    >
      <Select
        showSearch
        placeholder={placeholder}
        style={{ width: width, height: "50px" }}
        value={value}
        onChange={onChange}
        options={options}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        optionFilterProp="label"
      />
    </ConfigProvider>
  );
};

export default CustomSelect;
